import { FC } from "react";
import clsx from "clsx";
import { Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next"; // Import useTranslation

import { QuestionType } from "../../ExperimentTasting";

import {
  StyledExperimentQuestionContainer,
  StyledExperimentQuestionHeader,
  StyledExperimentQuestionItem,
  StyledExperimentQuestionOption,
  StyledExperimentQuestionOptions,
} from "styles/features/experiment";

interface ExperimentTastingQuestionProps {
  index?: number;
  question?: QuestionType;
  value?: "A" | "B" | "same";

  onOptionChange?: (value: "A" | "B" | "same") => void;
}

const ExperimentTastingQuestion: FC<ExperimentTastingQuestionProps> = ({
  index,
  question,
  value,
  onOptionChange,
}) => {
  const theme = useTheme();
  const { t } = useTranslation(); // Initialize translation

  return (
    <StyledExperimentQuestionItem>
      <StyledExperimentQuestionContainer>
        <StyledExperimentQuestionHeader>
          <Typography
            variant="bodyL"
            color={theme.palette.common.black}
            fontWeight={500}
            width="100%"
            textAlign={theme.direction === "rtl" ? "end" : "start"}
          >
            {t("question_number", { index })} {/* Use translation */}
          </Typography>
        </StyledExperimentQuestionHeader>
        <Typography
          variant="bodyM"
          color={theme.palette.customGrey.dark}
          fontWeight={300}
          textAlign={theme.direction === "rtl" ? "end" : "start"}
        >
          {question?.text}
        </Typography>
      </StyledExperimentQuestionContainer>
      <StyledExperimentQuestionOptions>
        <StyledExperimentQuestionOption
          className={clsx("lg", { active: value === "A" })}
          onClick={() => onOptionChange?.("A")}
        >
          {t("option_1")}
        </StyledExperimentQuestionOption>
        <StyledExperimentQuestionOption
          className={clsx("lg", { active: value === "B" })}
          onClick={() => onOptionChange?.("B")}
        >
          {t("option_2")}
        </StyledExperimentQuestionOption>
        <StyledExperimentQuestionOption
          className={clsx({ active: value === "same" })}
          onClick={() => onOptionChange?.("same")}
        >
          {t("the_same")}
        </StyledExperimentQuestionOption>
      </StyledExperimentQuestionOptions>
    </StyledExperimentQuestionItem>
  );
};

export default ExperimentTastingQuestion;
